import { useSetRecoilState } from "recoil"
import { Col, Container, Row, Table, Badge } from "../../components/UI"
import { dynamicNavs, UserIDSelector } from "../../states/atoms"
import { gql, useQuery } from "@apollo/client"
import { useLayoutEffect } from "react"
import { useRecoilValue } from "recoil"
import CardHori from "../../components/lectureCard/cardHori"
import {PageContainer} from '../addCoursePg/addcoursepg.style'

const QueryPublished = gql`
    query GetPublished($facId: String!, $offset: Int, $limit: Int) {
        GetPublished(facId: $facId, offset: $offset, limit: $limit) {
            id
            lid
            instiId
            facId
            facName
            facDep
            subject
            ltitle
            stitle
            cover {
                imgId
                provider
            }
            isDemo
            status
            lcount
            ltype
        }
    }
`

const ManageCourse = () => {
    const setDynamicNav = useSetRecoilState(dynamicNavs)
    const userid = useRecoilValue(UserIDSelector)
    useLayoutEffect(() => setDynamicNav(1))

    const {data, loading, error} = useQuery(QueryPublished, {
        variables: {
            facId: userid,
            offset: 0,
            limit: 20
        }
    })

    data && console.log(data)
    if(data)
    return(
        <PageContainer>
            <Row col="3">
                {data.GetPublished.map((row) => {
                    return(
                        <Col key={row.id}>
                            <CardHori ltitle={row.ltitle} stitle={row.stitle} subject={row.subject} cover={row.cover} />
                        </Col>
                    )
                })}
            </Row>
        </PageContainer>
    )
}

export default ManageCourse